import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { ClientesService } from 'src/app/services/clientes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';


@Component({
  selector: 'app-fiestas',
  templateUrl: './fiestas.component.html',
  styleUrls: ['./fiestas.component.scss']
})
export class FiestasComponent implements OnInit {
  enviroment = environment.BASE_URL;
  fiestas; 
  formulario;
  formularioEdit;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  imagenActual;
  respuestaFiestas:any;
  respuestaDatos:any;
  respuestaAgregar:any;
  respuestaUpdate:any;
  fiestaId;
  datos;
  data;
  fiestaid:any;

  constructor(private _getFiestas:ClientesService, private _getFiestaDetalle:ClientesService,
    private _agregarFiesta: ClientesService,
    private modalService: NgbModal,
    private _updateFiesta: ClientesService,
    private iziToast: Ng2IzitoastService
    ) { }

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 20,
      processing: true
    };

    this.formulario = {
      'nombre':'',
      'descripcion':'',
      'imagen':'',
      'precio':'',
      'precio_nino':'',
    }

    this.formularioEdit = {
      nombre: '',
      descripcion: '',
      imagen: '',
      precio: '',
      fiesta: '',
    }

    this.getFiestas();
  }

  getFiestas(){
    this._getFiestas.getFiestas().subscribe(
      data => {
        this.respuestaFiestas = data;
        if(this.respuestaFiestas.success){
          this.fiestas = this.respuestaFiestas.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  getFiestaDetalle(fiesta){
    this.data = {
      'fiesta':fiesta,
    }
    this._getFiestaDetalle.getFiestaDetalle(this.data).subscribe(
      data => {
        this.respuestaDatos = data;
        if(this.respuestaDatos.success){
          this.datos = this.respuestaDatos.content;
          this.formularioEdit.nombre = this.datos.nombre;
          this.formularioEdit.precio = this.datos.precio;
          this.formularioEdit.precio_nino = this.datos.precio_nino;
          this.formularioEdit.descripcion = this.datos.descripcion;
          this.imagenActual = this.datos.imagen;
          this.fiestaId = this.datos.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    )
  }


  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  agregarFiesta(){
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('descripcion', this.formulario.descripcion);
    formData.append('precio', this.formulario.precio);
    formData.append('precio_nino', this.formulario.precio_nino);

    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }


    this._agregarFiesta.agregarFiesta(formData).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.nombre = '';
          this.formulario.imagen = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getFiestas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  updateFiesta(fiesta){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('descripcion', this.formularioEdit.descripcion);
    formData.append('precio', this.formularioEdit.precio);
    formData.append('precio_nino', this.formularioEdit.precio_nino);
    formData.append('fiesta', fiesta);

    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }

    this._updateFiesta.updateFiesta(formData).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getFiestas();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
